module.exports = __webpack_public_path__ + "static/media/zadania-matematyczne-klasa-7-m4.4c6fa47b.jpg";